import styled from 'styled-components'

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
`

export const Content = styled.div`
    padding: 0;
`
